export default __webpack_public_path__ + "static/media/game_start.2f7e2b16.mp3";